<div>
  <div class="flex justify-between">
    <h3>Spørgsmål om nyhedsbrev?</h3>
    <mat-icon class="close-icon" (click)="closeModal()">close</mat-icon>
  </div>
  <div class="flex">
    <mat-icon class="material-symbols-outlined me-1">info</mat-icon>
    <p>
      Kunden modtager en SMS + email med link til at bekræfte sin tilmelding. Efter bekræftelsen modtager kunden vores
      velkomstflow med Rabat100*, som kan benyttes på næste køb. Kunden deltager samtidig i alle vores fede
      konkurrencer,
      herunder “vind dit køb”.
    </p>
  </div>
  <div class="flex">
    <mat-icon class="material-symbols-outlined me-1">info</mat-icon>
    <p>
      OBS: Rabat100 sendes kun til kunder, som ikke tidligere har modtaget nyhedsbrevet.
    </p>
  </div>
  <div class="flex">
    <mat-icon class="material-symbols-outlined me-1">info</mat-icon>
    <p>
      Alm. nyhedsbrev sendes 2 gange om dagen. Hvis kunden ikke er meget for at blive tilmeldt, kan muligheden for at
      vælge 1-2 mails om ugen benyttes.
    </p>
  </div>
</div>
